// extracted by mini-css-extract-plugin
export default {"wrap":"FJ-z","fullWidth":"GJ-z","hideOnDesktop":"HJ-z","content":"IJ-z","hasOpenedNav":"JJ-z","crumbsList":"KJ-z","dropdownsWrap":"LJ-z"};